module.exports = __webpack_public_path__ + "img/plan-03.801dff34.png";